import { SEARCH_LIMIT } from "./searchTypes";

export function asArray(value: unknown): any[] {
  if (Array.isArray(value)) return value;
  if (value && typeof value === "object") return Object.values(value);
  return [];
}

export function normalize(value: unknown): string {
  return String(value ?? "")
    .trim()
    .toLowerCase();
}

export function matchesQuery(query: string, ...fields: unknown[]): boolean {
  const q = normalize(query);
  if (!q) return false;
  return fields.some((field) => normalize(field).includes(q));
}

export function take<T>(items: T[], limit = SEARCH_LIMIT): T[] {
  return items.slice(0, limit);
}

export function joinParts(...parts: unknown[]): string {
  return parts
    .map((part) => String(part ?? "").trim())
    .filter(Boolean)
    .join(" · ");
}

export function coupleTitle(row: Record<string, any>): string {
  const his = [row.hisFirstName, row.hisLastName].filter(Boolean).join(" ").trim();
  const her = [row.herFirstName, row.herLastName].filter(Boolean).join(" ").trim();
  if (his && her) return `${his} & ${her}`;
  if (his || her) return his || her;
  if (row.primaryKey) return String(row.primaryKey);
  return "Couple";
}

export function personTitle(row: Record<string, any>): string {
  const name = [row.firstName, row.lastName].filter(Boolean).join(" ").trim();
  if (name) return name;
  if (row.name) return String(row.name);
  if (row.userName) return String(row.userName);
  return row.email || row.eMail || "User";
}

export function formatDateRange(
  from?: string | null,
  to?: string | null,
): string {
  const fmt = (value?: string | null) => {
    if (!value) return "";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    return date.toLocaleDateString(undefined, {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };
  const start = fmt(from);
  const end = fmt(to);
  if (start && end && start !== end) return `${start} – ${end}`;
  return start || end;
}

export function retreatTitle(row: Record<string, any>): string {
  return (
    row.title ||
    row.heading ||
    row.parishName ||
    (row.id != null ? `Retreat ${row.id}` : "Retreat")
  );
}
